import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-date-from-to',
  templateUrl: './fb-basic-input-date-from-to.component.html',
  styleUrls: ['./fb-basic-input-date-from-to.component.css']
})
export class FbCoreBasicInputDateFromToComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

    get placeholder2(): string {
        return this.data.component.placeholder2;
    }

    getControlName(input: string): string {
        return this.data.controlName + '.' + input;
    }

}
